import styles from './Spinner.module.scss';

interface SpinnerProps {
  label?: string;
}

export function Spinner({ label = 'Загрузка' }: SpinnerProps) {
  return (
    <div className={styles.wrapper} role="status" aria-live="polite">
      <span className={styles.circle} aria-hidden />
      <span className={styles.label}>{label}</span>
    </div>
  );
}
